var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTerminal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M388.129,322.065v41.29h99.097v-41.29c0-4.561-3.697-8.258-8.258-8.258h-82.581   C391.826,313.806,388.129,317.504,388.129,322.065z",
    fill: "#eceaec"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.129,
    y: 330.323,
    style: {},
    width: 99.097,
    height: 33.032,
    fill: "#dad8db"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M41.29,462.452H24.774c-4.561,0-8.258-3.697-8.258-8.258v-24.774h33.032v24.774   C49.548,458.754,45.851,462.452,41.29,462.452z",
    fill: "#4b3f4e",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M487.226,462.452H470.71c-4.561,0-8.258-3.697-8.258-8.258v-24.774h33.032v24.774   C495.484,458.754,491.787,462.452,487.226,462.452z",
    fill: "#4b3f4e",
    className: ""
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.613,
    y: 297.29,
    style: {},
    width: 132.129,
    height: 57.806,
    fill: "#5d5360",
    className: ""
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.613,
    y: 297.29,
    style: {},
    width: 132.129,
    height: 33.032,
    fill: "#4b3f4e",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M330.323,49.548H33.032c-9.122,0-16.516,7.395-16.516,16.516V297.29   c0,9.122,7.395,16.516,16.516,16.516h297.29c9.122,0,16.516-7.395,16.516-16.516V66.065   C346.839,56.943,339.444,49.548,330.323,49.548z",
    fill: "#6f6571",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M305.548,272.516H57.806c-4.561,0-8.258-3.697-8.258-8.258V90.839c0-4.561,3.697-8.258,8.258-8.258   h247.742c4.561,0,8.258,3.697,8.258,8.258v173.419C313.806,268.819,310.109,272.516,305.548,272.516z",
    fill: "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M495.484,445.935H16.516C7.395,445.935,0,438.541,0,429.419v-66.065   c0-9.122,7.395-16.516,16.516-16.516h478.968c9.122,0,16.516,7.395,16.516,16.516v66.065   C512,438.541,504.605,445.935,495.484,445.935z",
    fill: "#6f6571",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M330.323,388.129H33.032c-4.565,0-8.258-3.694-8.258-8.258s3.694-8.258,8.258-8.258h297.29   c4.565,0,8.258,3.694,8.258,8.258S334.887,388.129,330.323,388.129z",
    fill: "#4b3f4e",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M379.871,107.355h-33.032V256h33.032c4.561,0,8.258-3.698,8.258-8.258V115.613   C388.129,111.052,384.432,107.355,379.871,107.355z",
    fill: "#6f6571",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M239.484,222.968H123.871c-9.122,0-16.516-7.395-16.516-16.516v-57.806   c0-9.122,7.395-16.516,16.516-16.516h115.613c9.122,0,16.516,7.395,16.516,16.516v57.806   C256,215.573,248.605,222.968,239.484,222.968z",
    fill: "#ffe07d",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M222.968,198.194h-82.581c-4.565,0-8.258-3.694-8.258-8.258s3.694-8.258,8.258-8.258h82.581   c4.565,0,8.258,3.694,8.258,8.258S227.532,198.194,222.968,198.194z",
    fill: "#eceaec"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M33.032,272.516V49.548c-9.121,0-16.516,7.394-16.516,16.516V297.29   c0,9.122,7.395,16.516,16.516,16.516h297.29c9.121,0,16.516-7.395,16.516-16.516H57.806   C44.124,297.29,33.032,286.199,33.032,272.516z",
    fill: "#5d5360",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M16.516,404.645v-57.806C7.395,346.839,0,354.233,0,363.355v66.065   c0,9.122,7.395,16.516,16.516,16.516h478.968c9.121,0,16.516-7.395,16.516-16.516H41.29   C27.608,429.419,16.516,418.328,16.516,404.645z",
    fill: "#5d5360",
    className: ""
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.097,
    y: 346.839,
    style: {},
    width: 16.516,
    height: 99.097,
    fill: "#5d5360",
    className: ""
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.097,
    y: 429.419,
    style: {},
    width: 16.516,
    height: 16.516,
    fill: "#4b3f4e",
    className: ""
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.613,
    y: 396.387,
    style: {},
    width: 140.387,
    height: 16.516,
    fill: "#5d5360",
    className: ""
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.839,
    y: 107.355,
    style: {},
    width: 16.516,
    height: 148.645,
    fill: "#5d5360",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M123.871,189.935v-57.806c-9.121,0-16.516,7.394-16.516,16.516v57.806   c0,9.121,7.395,16.516,16.516,16.516h115.613c9.121,0,16.516-7.395,16.516-16.516H140.387   C131.266,206.452,123.871,199.057,123.871,189.935z",
    fill: "#ffd064"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminal);
export default __webpack_public_path__ + "static/media/terminal.fe1e77a0dcf9bd3d3a47c2d87ab858b6.svg";
export { ForwardRef as ReactComponent };